import { Box, styled, Typography } from '@mui/material';
import React from 'react';
import { Product } from '../../../models/Product';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const StyledTitleWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
}));

const StyledTitle = styled(Link)(({ theme }) => ({
    color: 'black',
    fontWeight: '500',
}));

export const CollectionProductTitle: React.FC<{
    product: Product;
    collectionHandle: string;
    variantSku: string;
}> = (props) => {
    const { product, collectionHandle, variantSku } = props;
    const { t } = useTranslation('collection', {
        keyPrefix: 'COLLECTIONS',
    });

    return (
        <StyledTitleWrapper>
            <Box>
                <Typography>
                    <StyledTitle
                        to={
                            '/collections/' +
                            collectionHandle +
                            '/products/' +
                            product.handle
                        }
                    >
                        {product.title}
                    </StyledTitle>
                </Typography>
                <Typography sx={{ color: '#999' }}>
                    <>
                        {t('PRODUCT.SKU')}: {variantSku}
                    </>
                </Typography>
            </Box>
        </StyledTitleWrapper>
    );
};
